import React, { memo } from 'react';
import { MenuSection, MenuSectionHeading, MenuList } from '@atlaskit/navigation-system';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import LinkMenuItem from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/link-menu-item-with-analytics/index.tsx';
import { COMMON_ANALYTICS_ATTRIBUTES } from '../../common/constants.tsx';
import messages from './messages.tsx';

const CustomerServiceSection = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const currentRoute = useCurrentRoute();

	return (
		<MenuSection isMenuListItem={fg('platform_design_system_nav4_sidenav_a11y')}>
			<MenuSectionHeading>
				{fg('csm_rename_jcs_to_csm')
					? formatMessage(messages.heading)
					: formatMessage(messages.headingOld)}
			</MenuSectionHeading>
			<MenuList>
				<LinkMenuItem
					analytics={{
						...COMMON_ANALYTICS_ATTRIBUTES,
						section: 'jiraCustomerService',
						itemId: 'customerAccess',
					}}
					isSelected={currentRoute.name === 'products-jcs-customer-access'}
					href="/jira/settings/products/customerservice/customer-access"
				>
					{formatMessage(messages.customerAccessItem)}
				</LinkMenuItem>
				{fg('jcs_forms_resiliency_fast_follows') && (
					<LinkMenuItem
						analytics={{
							...COMMON_ANALYTICS_ATTRIBUTES,
							section: 'jiraCustomerService',
							itemId: 'customerAccess',
						}}
						isSelected={currentRoute.name === 'products-jcs-form-fields'}
						href="/jira/settings/products/customerservice/form-fields"
					>
						{formatMessage(messages.formFieldsItem)}
					</LinkMenuItem>
				)}
			</MenuList>
		</MenuSection>
	);
};

export default memo(CustomerServiceSection);
